import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';

interface LogoProps {
  variant?: 'full' | 'icon' | 'text';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  light?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  variant = 'full',
  size = 'md',
  className = '',
  light = false
}) => {
  const { user } = useAuth();
  const linkTo = user ? "/dashboard" : "/";
  
  const sizeClasses = {
    sm: {
      container: 'h-8 flex items-center',
      img: variant === 'icon' ? 'h-5 w-5' : 'h-8 w-[80%]'
    },
    md: {
      container: 'h-10 flex items-center',
      img: variant === 'icon' ? 'h-6 w-6' : 'h-10 w-[80%]'
    },
    lg: {
      container: 'h-12 flex items-center',
      img: variant === 'icon' ? 'h-7 w-7' : 'h-12 w-[80%]'
    }
  };

  // Use the appropriate logo based on the light/dark mode and variant
  const logoSrc = variant === 'icon'
    ? "/images/emblem.png" // Use emblem for icon variant
    : light 
      ? "/images/light-logo.png" // Light logo for dark backgrounds
      : "/images/dark-logo.png"; // Dark logo for light backgrounds

  return (
    <Link 
      to={linkTo}
      className={`flex items-center ${variant === 'icon' ? 'justify-center w-full' : 'gap-2'} ${className}`}
    >
      <div className={`${sizeClasses[size].container} ${variant === 'icon' ? 'justify-center w-full' : ''}`}>
        <img 
          src={logoSrc}
          alt="RoundOne AI"
          className={`${sizeClasses[size].img} object-contain`}
        />
      </div>
    </Link>
  );
};

export default Logo;